export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_1-e404aa86eb505d159474b24e8d15f291.png";